"use client";
import { useToast } from "@/components/ui/use-toast";
import useIsMobile from "@/hooks/useIsMobile";
import { getAccessToken } from "@/lib/auth";
import { useGetUserDetailsQuery } from "@/redux/apiSlices/userApi";
import { useGetCartListQuery } from "@/redux/apiSlices/userCartApi";
import { setBearerToken } from "@/redux/slices/authSlice";
import { setUserLocation } from "@/redux/slices/locationSlice";
import { setUserCart } from "@/redux/slices/userCartSlice";
import { setUserDetails } from "@/redux/slices/userSlice";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

export const UserProvider = () => {
  const { isLogin } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { toast } = useToast();
  const { data } = useGetUserDetailsQuery(
    {},
    {
      skip: !isLogin,
    }
  );
  const { data: userDetails } = data || {};
  const { data: cartApiData, refetch } = useGetCartListQuery();

  // const updatedCartItems = cartApiData?.data || {};
  const updatedCartItems = useMemo(
    () => cartApiData?.data || {},
    [cartApiData]
  );
  const isMobile = useIsMobile(1023);

  useEffect(() => {
    refetch();
  }, [isLogin, refetch]);

  useEffect(() => {
    if(!userDetails) return;
    dispatch(setUserDetails(userDetails));
  }, [userDetails, dispatch]);

  useEffect(() => {
    dispatch(setUserCart(updatedCartItems));
  }, [updatedCartItems, dispatch]);

  useEffect(() => {
    const token = getAccessToken();
    if (token) {
      dispatch(setBearerToken({ token, isLogin: true }));
    }
  }, [dispatch]);
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        try {
          const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
          );
          const data = await response.json();

          const addressComponents = data.results[0]?.address_components || [];

          // Extract country state and postal code
          const country =
            addressComponents.find((c) => c.types.includes("country"))
              ?.short_name || "";

          const state =
            addressComponents.find((c) =>
              c.types.includes("administrative_area_level_1")
            )?.short_name || "";

          const pincode = addressComponents.find((c) =>
            c.types.includes("postal_code")
          )?.long_name;

          // Check if the country is in North America (US, CA, MX)
          const isNorthAmerica = ["US"].includes(country);
          const isCalifornia = isNorthAmerica && state === "CA";
          const selectedPincode = isCalifornia
            ? pincode || "Zipcode not found"
            : "94545";

          dispatch(
            setUserLocation(
              isCalifornia
                ? {
                    latlng: { lat: latitude, long: longitude },
                    zipCode: selectedPincode,
                  }
                : { zipCode: selectedPincode }
            )
          );
          if (!isMobile) {
            if (!isCalifornia) {
              toast({
                title: "Delivery Unavailable",
                description:
                  "We are not delivering outside California, hence the default store is selected.",
                variant: "destructive",
              });
            }
          }
        } catch {
          toast({ title: "Error fetching pincode", variant: "destructive" });
        }
      },
      (err) => {
        console.log("%c" + err.message, "color: red; font-weight: bold;");
      }
    );
  }, [dispatch, isMobile, toast]);
};